// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"895f9c7c","376":"4fe0e0a5","585":"d8012bf7","862":"f03f621b"}[chunkId] + ".chunk.js";
};